import { toastr } from "react-redux-toastr"
import { IFileDetails, ITranslations } from ".."

interface IFileInfos {
  path: string
  name: string
}

export default IFileInfos

export const checkFileProps = (
  file: File,
  files: IFileDetails[],
  fieldName: string,
  translations: ITranslations["productForm"]
): boolean => {
  for (const key in files) {
    if (files[key].file.name === file.name) {
      toastr.warning(
        file.name + " : " + translations.errorFileAlreadyUploaded,
        ""
      )
      return false
    }
  }
  if (fieldName === "pictures") {
    if (file.type.indexOf("image") < 0) {
      toastr.warning(file.name + " : " + translations.errorFileNotSupported, "")
      return false
    }
    const maxFileSize =
      parseInt(translations.imageMaxSize || "25", 10) * 1000000
    if (file.size > maxFileSize) {
      toastr.warning(
        file.name +
          " : " +
          translations.errorFileTooHeavy +
          " (max: " +
          translations.imageMaxSize +
          "Mo)",
        ""
      )
      return false
    }
  } else if (fieldName === "pdf") {
    if (file.type.indexOf("pdf") < 0) {
      toastr.warning(file.name + " : " + translations.errorFileNotSupported, "")
      return false
    }
  }

  return true
}

export const checkFilePresenceForRestore = (
  file: IFileInfos,
  files: IFileDetails[],
  translations: ITranslations["productForm"]
): boolean => {
  for (const key in files) {
    if (
      files[key].file.name === file.name ||
      (files[key].path && files[key].path === file.path)
    ) {
      toastr.warning(
        file.name + " : " + translations.errorFileAlreadyUploaded,
        ""
      )
      return false
    }
  }
  return true
}
